import { IRoleActionTypes } from "../../action-types/user/IRoleActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IRoleReducer } from "../../reducer-model/user/IRoleReducer";
const iniState: IRoleReducer = {
    status: eReducerStatusBase.is_not_initialization,
    roles: []
}
export const roleReducer = (state: IRoleReducer=iniState, action: IRoleActionTypes): IRoleReducer => {
    switch (action.type) {
        case "ROLE_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "ROLE_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                roles: action.payload
            }
        case "ROLE_LOAD_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                roles: []
            }

        case "ROLE_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                roleEditing: action.payload
            }
        case "ROLE_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                roleEditing: undefined
            }
        case "ROLE_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "ROLE_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false
            }
        case "ROLE_DELETE_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "ROLE_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "ROLE_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "ROLE_SAVE_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }

        default:
            return {
                ...state
            };
    }
}